<template>
  <v-dialog v-model="dialog" max-width="900px">
    <v-card class="pa-2">
      <v-card-title>{{ $t("parts.inventory.actions.shareData") }}</v-card-title>
      <v-card-text class="pt-2 pb-4">
        <div class="share-options-grid">
          <button
            type="button"
            class="share-option"
            @click="shareWhatsApp"
          >
            <div class="share-option-icons">
              <v-icon color="green" size="32">mdi-whatsapp</v-icon>
            </div>
            <span class="share-option-label">WhatsApp</span>
          </button>

      <!--    <button
            type="button"
            class="share-option"
            @click="shareSubito"
          >
            <div class="share-option-icons">
              <img
                height="32"
                width="32"
                src="@/assets/icons/subito.png"
                alt="Subito"
              />
            </div>
            <span class="share-option-label">Subito</span>
          </button>
-->
          <button
            v-if="hasEbayShare"
            type="button"
            class="share-option"
            @click="shareEbay"
          >
            <div class="share-option-icons">
              <v-icon color="green" size="32">mdi-whatsapp</v-icon>
              <img
                height="32"
                width="32"
                src="@/assets/icons/ebay_colored.png"
                alt="eBay"
              />
            </div>
            <span class="share-option-label">
              {{ $t("parts.inventory.share_ebay") }}
            </span>
          </button>

          <button
            v-if="rrMember"
            type="button"
            class="share-option"
            @click="shareRr"
          >
            <div class="share-option-icons">
              <v-icon color="green" size="32">mdi-whatsapp</v-icon>
              <img
                height="32"
                width="32"
                src="@/assets/rr-logo.png"
                alt="RR"
              />
            </div>
            <span class="share-option-label">
              {{ $t("parts.inventory.share_rr") }}
            </span>
          </button>

          <button
            v-if="rrMember"
            type="button"
            class="share-option"
            @click="shareRrWithoutDetails"
          >
            <div class="share-option-icons">
              <v-icon color="green" size="32">mdi-whatsapp</v-icon>
              <img
                height="32"
                width="32"
                src="@/assets/rr-logo.png"
                alt="RR"
              />
            </div>
            <span class="share-option-label">
              {{ $t("parts.inventory.share_rr_without_details") }}
            </span>
          </button>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import JSZip from "jszip";
import config from "../../config";
import getRequest from "../../api/getRequest";

export default {
  components: {},
  data: () => ({
    dialog: false,
    items: [],
  }),
  computed: {
    ...mapGetters(["rr_member"]),
    rrMember() {
      return this.rr_member === true;
    },
    hasEbayShare() {
      return Boolean(this.items[0] && this.items[0].eBayStatus);
    },
    shareRrUrl() {
      return this.items
        .map(
          (item) =>
            `${config.getReteRicambiFrontUri()}/productDetails/${item._id}`,
        )
        .join("\n");
    },
    shareRrWithoutDetailsUrl() {
      return this.items
        .map(
          (item) =>
            `${config.getReteRicambiFrontUri()}/mechanic-productDetails/${item._id}`,
        )
        .join("\n");
    },
    // getUrl() {
    //   return this.items.reduce(
    //     (accumulator, item) =>
    //       `${accumulator}${config.getShopUri()}/share/part/${item._id}\n`,
    //     "",
    //   );
    // },
    getUrl() {
      return this.items
        .map((item) => `${config.getShopUri()}/share/part/${item._id}`)
        .join("\n");
    },
    ebay() {
      const listings = this.items[0].eBayListings;
      const countryPriority = ["it", "de", "fr", "es"];
      const countryTitles = {
        it: "eBay IT",
        de: "eBay DE",
        fr: "eBay FR",
        es: "eBay ES",
      };

      for (const country of countryPriority) {
        const items = listings[country];
        if (items && items.length > 0) {
          return `${countryTitles[country]} https://www.ebay.${country}/itm/${items[0]}`;
        }
      }
      // If none of the preferred sites have listings
      return "";
    },
  },
  methods: {
    shareEbay() {
      this.openWhatsAppShare(this.ebay);
    },
    shareWhatsApp() {
      this.openWhatsAppShare(this.getUrl);
    },
    shareRr() {
      this.openWhatsAppShare(this.shareRrUrl);
    },
    shareRrWithoutDetails() {
      this.openWhatsAppShare(this.shareRrWithoutDetailsUrl);
    },
    openWhatsAppShare(text) {
      const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
      const width = 800;
      const height = 500;
      const left = (window.innerWidth - width) / 2;
      const top = (window.innerHeight - height) / 2;

      window.open(
        url,
        "Share on WhatsApp",
        `width=${width},height=${height},top=${top},left=${left},resizable,scrollbars=yes,status=1`,
      );
    },
    open(data) {
      this.items = data;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$emit("close");
    },
    async shareSubito() {
      const promises = this.items.map(async (i) => {
        const d = await getRequest(`/info-car/id/${i.infoCar._id}`).catch(
          (e) => e,
        );
        const brand =
          d && d.applicability && d.applicability.length
            ? d.applicability[0].brand
            : "";
        const model =
          d && d.applicability && d.applicability.length
            ? d.applicability[0].model
            : "";
        const version =
          d &&
          d.applicability &&
          d.applicability.length &&
          d.applicability[0].versions &&
          d.applicability[0].versions.length
            ? d.applicability[0].versions[0].version
            : "";

        // <email>${i.institution_id.email}</email>
        return `
        <ad>
          <type>sell</type>
          <category>accessori-auto</category>
          <ad_code>${i.old_id.slice(i.old_id.length - 6, i.old_id.length)}</ad_code>
          <subject><![CDATA[ ${i.infoCar.description.descriptionId.title.it} ]]></subject>
          <body>
            <![CDATA[ ${i.infoCar.description.descriptionId.category.it} ${i.infoCar.description.descriptionId.title.it} ${brand} ${model}
              DETTAGLI
              - Marca: ${brand}
              - ${model}
              - ${version}
              - Codice del Pezzo: ${i.manufacturer_code}
              - Codice OEM: ${i.infoCar.oemCode}
              - Note: ${i.notes}
            ]]>
          </body>
          <features>
            <geo>
              <town>
                <id>026086</id>
              </town>
              <province>
                <id><![CDATA[TV]]></id>
              </province>
            </geo>
            <price type="integer"> ${i.price} </price>
          </features>
          <advertiser>
            <email>tester.subito@gmail.com</email>
            <phone_hidden type="boolean">false</phone_hidden>
            <phone>${i.institution_id.phone}</phone>
            <company type="boolean">true</company>
            <name><![CDATA[${i.institution_id.title}]]></name>
          </advertiser>
          <images>
            ${i.images.map((img) => `<image><![CDATA[http://api.lekotech.com/images?date=${i.date_created}&q=${i._id}-${img}]]></image>`).join("")}
          </images>
        </ad>
        `;
      });

      const items = await Promise.all(promises);
      const xml = `
      <?xml version="1.0" encoding="UTF-8"?>
        <ads>
          ${items.join("\n")}
        </ads>
      `;

      const zip = new JSZip();
      zip.file("data.xml", xml.trim());
      zip.generateAsync({ type: "blob" }).then((result) => {
        const url = window.URL.createObjectURL(result);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "data.xml.zip");
        document.body.appendChild(link);
        link.click();
      });
    },
  },
};
</script>

<style scoped>
.share-options-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}

.share-option {
  display: flex;
  flex: 1 1 150px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 150px;
  max-width: 200px;
  min-height: 110px;
  padding: 16px 12px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.share-option:hover {
  background-color: #fafafa;
  border-color: rgba(0, 0, 0, 0.24);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.share-option:focus-visible {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.share-option-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 10px;
}

.share-option-label {
  font-size: 14px;
  line-height: 1.35;
  color: rgba(0, 0, 0, 0.87);
  text-align: center;
  word-break: break-word;
}
</style>
